import type { SavingsInsightsLastRequestParams } from '../types/ReportSavingsSummarySchema';
import type { StateSchema } from 'app/providers/StoreProvider';

export const getReportSavingsSummary = (state: StateSchema) =>
    state?.reportSavingsSummary?.summary;

export const getReportSavingsSummaryLoading = (state: StateSchema) =>
    state?.reportSavingsSummary?.summaryLoading;

export const getReportSavingsSummaryError = (state: StateSchema) =>
    state?.reportSavingsSummary?.summaryError;

export const getReportSavingsProducts = (state: StateSchema) =>
    state?.reportSavingsSummary?.products;

export const getReportSavingsProductsLoading = (state: StateSchema) =>
    state?.reportSavingsSummary?.productsLoading;

export const getReportSavingsProductsError = (state: StateSchema) =>
    state?.reportSavingsSummary?.productsError;

export const getReportSavingsMissedProducts = (state: StateSchema) =>
    state?.reportSavingsSummary?.missedProducts;

export const getReportSavingsMissedProductsLoading = (state: StateSchema) =>
    state?.reportSavingsSummary?.missedProductsLoading;

export const getReportSavingsMissedProductsError = (state: StateSchema) =>
    state?.reportSavingsSummary?.missedProductsError;

export const getReportSavingsByCategory = (state: StateSchema) =>
    state?.reportSavingsSummary?.byCategory ?? [];

export const getReportSavingsByCategoryLoading = (state: StateSchema) =>
    state?.reportSavingsSummary?.byCategoryLoading;

export const getReportSavingsByCategoryError = (state: StateSchema) =>
    state?.reportSavingsSummary?.byCategoryError;

export const getReportSavingsOvertime = (state: StateSchema) =>
    state?.reportSavingsSummary?.overtime ?? [];

export const getReportSavingsOvertimeLoading = (state: StateSchema) =>
    state?.reportSavingsSummary?.overtimeLoading;

export const getReportSavingsOvertimeError = (state: StateSchema) =>
    state?.reportSavingsSummary?.overtimeError;

export const getReportSavingsLastRequestParams = (
    state: StateSchema,
): SavingsInsightsLastRequestParams | null =>
    state?.reportSavingsSummary?.lastRequestParams ?? null;
